/**
 * Catalogue for the AI writing tools shown above the article body editor.
 * Actions and tone keys mirror backend/lib/article-assist.js.
 */

export const ASSIST_TOOLS = [
    { action: 'improve', icon: 'fa-solid fa-wand-magic-sparkles', textId: 'article.aiImprove', text: 'Improve language' },
    { action: 'proofread', icon: 'fa-solid fa-spell-check', textId: 'article.aiProofread', text: 'Proofread' },
    { action: 'shorten', icon: 'fa-solid fa-compress', textId: 'article.aiShorten', text: 'Shorter' },
    { action: 'expand', icon: 'fa-solid fa-expand', textId: 'article.aiExpand', text: 'Longer' },
    { action: 'tone', icon: 'fa-solid fa-masks-theater', textId: 'article.aiTone', text: 'Change tone' },
    { action: 'structure', icon: 'fa-solid fa-list-tree', textId: 'article.aiStructure', text: 'Add structure' },
    { action: 'continue', icon: 'fa-solid fa-forward', textId: 'article.aiContinue', text: 'Continue writing' },
    { action: 'bullets', icon: 'fa-solid fa-list-ul', textId: 'article.aiBullets', text: 'Key points' },
    { action: 'titleIngress', icon: 'fa-solid fa-heading', textId: 'article.aiTitleIngress', text: 'Suggest title & intro' },
];

export const TONE_OPTIONS = [
    { value: 'neutral', textId: 'article.aiToneNeutral', text: 'Neutral' },
    { value: 'engaging', textId: 'article.aiToneEngaging', text: 'Engaging' },
    { value: 'formal', textId: 'article.aiToneFormal', text: 'Formal' },
];

// Actions whose result replaces the body: shown as a change view (diff) in the preview.
const REWRITE_ACTIONS = ['improve', 'proofread', 'shorten', 'expand', 'tone', 'structure', 'custom'];

export function isRewriteAction(action) {
    return REWRITE_ACTIONS.includes(action);
}

export function assistResultButtons(action) {
    if (action === 'titleIngress') return ['useTitle', 'useIngress', 'discard'];
    if (action === 'continue') return ['append', 'discard'];
    return ['replace', 'append', 'discard'];
}

export function buildAssistPayload(article = {}, { action, tone = '', instruction = '' } = {}) {
    return {
        action,
        body: article.body || '',
        title: article.title || '',
        ingress: article.ingress || '',
        tone: tone || '',
        instruction: (instruction || '').trim(),
    };
}
